import { useEffect, useState } from "react";
import api from "../api/adminApi";
import AdminLayout from "./AdminLayout";
import "./admin.css";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/estadisticas")
      .then(res => setStats(res.data))
      .catch(err => console.error("Error cargando estadísticas:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <AdminLayout>Cargando...</AdminLayout>;
  }

  if (!stats) {
    return <AdminLayout>Error al cargar datos</AdminLayout>;
  }

  return (
    <AdminLayout>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Ganado</h3>
          <p>${stats.totalGanado}</p>
        </div>

        <div className="stat-card">
          <h3>Cursos Disponibles</h3>
          <p>{stats.totalCursos}</p>
        </div>
      </div>

      <h2 style={{ marginTop: "30px" }}>Últimas compras</h2>

      <div className="table-container">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Curso</th>
              <th>Cliente</th>
              <th>Monto</th>
              <th>Estado</th>
              <th>Fecha</th>
            </tr>
          </thead>

          <tbody>
            {stats.ultimasCompras.length === 0 ? (
              <tr>
                <td colSpan="5">No hay compras registradas</td>
              </tr>
            ) : (
              stats.ultimasCompras.map((c) => (
                <tr key={c.id}>
                  <td>{c.nombre_curso}</td>
                  <td>{c.nombre_cliente}</td>
                  <td>${c.monto}</td>
                  <td>{c.estado}</td>
                  <td>{new Date(c.fecha).toLocaleDateString("es-CL")}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
